import { AsyncBlastRadiusCanvas } from '@atlassian/ai-mate-jira-admin-agent/AsyncBlastRadiusCanvas';
import { RovodalCanvasKeys } from '@atlassian/rovodal-context/canvas-keys';

import { type RovodalCanvasRegistry } from '../types';

/*
Canvas key -> canvas component. The host resolves the canvas for an open
Rovodal from this map using `state.canvasKey` (falling back to the entry's key).
*/
export const rovodalCanvasRegistry: RovodalCanvasRegistry = {
	[RovodalCanvasKeys.jiraAdminAgentBlastRadiusCanvas]: AsyncBlastRadiusCanvas,
};
